module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum06-cf85ec3cb823f495b60b19eed4ca79ad.png";